/*
  "Email me when it's back", posting to the mizziburlo Helpdesk through the app
  proxy. Replaces the Notify Me app's widget so no third-party script has to
  load on every product page for a field most visitors never use.

  It decides when to appear by watching the add-to-cart button's disabled
  state, which is how the theme expresses a sold-out variant. That keeps it
  working through variant switching without knowing how the picker is built.
*/

(function () {
  const roots = document.querySelectorAll('[data-boost-restock]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const form = root.querySelector('[data-boost-restock-form]');
    const input = root.querySelector('input[type="email"]');
    const message = root.querySelector('[data-boost-restock-message]');
    const button = form.querySelector('button');
    const container = root.closest('product-form, .product-form, form, .product__info-container') || document;

    const addButton = () =>
      container.querySelector('[name="add"], button[type="submit"][name="add"], .product-form__submit');

    const currentVariantId = () => {
      const field = container.querySelector('input[name="id"], select[name="id"]');
      const fromForm = field && field.value;
      if (fromForm) return fromForm;
      const fromUrl = new URLSearchParams(window.location.search).get('variant');
      return fromUrl || '';
    };

    const soldOut = () => {
      const btn = addButton();
      if (!btn) return false;
      if (btn.hasAttribute('disabled')) return true;
      // Some themes swap the label rather than disabling the control.
      return /sold\s*out|out of stock/i.test(btn.textContent || '');
    };

    const sync = () => {
      const show = soldOut();
      root.hidden = !show;
      if (!show && message) {
        message.hidden = true;
        message.textContent = '';
      }
    };

    sync();
    // The variant picker replaces this markup on change, so watch rather than
    // bind once.
    const observed = addButton();
    if (observed) {
      new MutationObserver(sync).observe(observed, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    }
    document.addEventListener('variant:change', sync);
    document.addEventListener('change', (e) => {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, [name="id"]')) {
        setTimeout(sync, 350);
      }
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = (input.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        show('Enter a valid email address.', true);
        input.focus();
        return;
      }

      const label = button.textContent;
      button.disabled = true;
      button.textContent = 'Saving…';

      fetch(root.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          productId: root.dataset.productId,
          productHandle: root.dataset.productHandle,
          productTitle: root.dataset.productTitle,
          variantId: currentVariantId(),
          variantTitle: (container.querySelector('[name="id"] option:checked') || {}).textContent || null,
        }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.ok) {
            show(data.message || "Done — we'll email you when it's back.", false);
            form.hidden = true;
          } else {
            show((data && data.error) || 'Something went wrong — please try again.', true);
          }
        })
        .catch(() => show('Something went wrong — please try again.', true))
        .finally(() => {
          button.disabled = false;
          button.textContent = label;
        });
    });

    function show(text, isError) {
      if (!message) return;
      message.hidden = false;
      message.textContent = text;
      message.classList.toggle('boost-restock__message--error', !!isError);
    }
  });
})();
